import { useTranslation } from "react-i18next";
import { Navigation } from "../../components";
import {
  Typography,
  Box,
  TableContainer,
  TableHeader,
  PageContainer,
} from "../../shared/ui";
import css from "./MyBets.module.scss";

const tableHeader = [
  { label: "Date/Time", alignment: "left" },
  { label: "Bet", alignment: "center" },
  { label: "X", alignment: "center" },
  { label: "Win USD", alignment: "right" },
];

export const MyBets = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Navigation title={t("my_bets.title").toUpperCase()} />
      <PageContainer>
        <Typography color="header-small" variant="caption2">
          {t("my_bets.select_bet_to_check")}
        </Typography>

        <TableContainer className={css.tableContainer}>
          <TableHeader columns={tableHeader} />
          <div className={css.betList}>
            {/* {userData.bets.map((bet) => (
              <BetEntry key={bet.id} />
            ))} */}
          </div>
        </TableContainer>
      </PageContainer>
    </Box>
  );
};
